/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-use-before-define */
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import DataNotAvailablePage from 'reusable-components/data-not-found';
import useMessageDispatcher from '../../../hooks/useMessageDispatcher';
import axios from 'axios';

const headers = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken') || window.localStorage.getItem('webViewToken')}`,
        'Content-Type': 'application/json'
    }
};

const LabelledField = ({ label, children, labelWidth = '190px' }) => (
    <Box
        mb={1.5}
        sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { sm: 'center' },
            gap: 1
        }}
    >
        <Typography sx={{ width: { xs: '100%', sm: labelWidth }, fontSize: '14px', fontWeight: 'bold' }}>{label}</Typography>
        {children}
    </Box>
);

const CustomTextField = (props) => (
    <TextField
        variant="standard"
        fullWidth
        size="small"
        InputProps={{
            style: {
                fontSize: '0.85rem',
                padding: 0,
                disableUnderline: false
            }
        }}
        sx={{
            bgcolor: '#ddb8ef',
            '& .MuiOutlinedInput-root': {
                borderRadius: 0,
                '& fieldset': {
                    border: '1px solid #4a2a82',
                    borderRadius: 0
                },
                '&:hover fieldset': {
                    border: '1px solid #4a2a82'
                },
                '&.Mui-focused fieldset': {
                    border: '1px solid #4a2a82'
                }
            }
        }}
        {...props}
    />
);

const ExtraCurricular = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [activities, setActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState([]);
    const [totalActivityAmount, setTotalActivityAmount] = useState(0);
    const [openActivity, setOpenActivity] = useState(false);
    const [activitySubscriptionId, setActivitySubscriptionId] = useState('');
    const [signature, setSignature] = useState('');
    const navigate = useNavigate();
    const showMessage = useMessageDispatcher();
    const location = useLocation();
    const studentData = location.state?.studentData;
    console.log(studentData, 'studentDatastudentData');

    const fetchSignature = async (fileName) => {
        axios.post(`/v1/utils/file/download`, { fileName }, headers).then((result) => {
            setSignature(result.data.data);
        });
    };
    const fetchIntrestCategories = async () => {
        try {
            const response = await axios.get(
                `/v1/fees/expression-of-interest-category-fees?interestType=ACTIVITY&batchId=${studentData?.sessionId}`,
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    const data = response?.data?.data;
                    const newData = data?.map((item) => item?.subHeads).flat();
                    setActivities(newData);
                    fetchSubscriptions();
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const handleSubscription = async () => {
        const payload = {
            interestType: 'ACTIVITY',
            subscriptionItems: selectedActivity,
            userId: studentData?.userId
        };
        try {
            setIsLoading(true);
            const response = await axios.post(`/v1/fees/expression-of-interest-subscription`, payload, headers);
            if (response.status === 200) {
                navigate(-1);
                setIsLoading(false);
                fetchSubscriptions();
                if (response.data.code !== '403') {
                    showMessage({ message: response?.data?.Msg, color: 'success' });
                }
            }
        } catch (error) {
            setIsLoading(false);
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchSubscriptions = async () => {
        try {
            const response = await axios.get(
                `/v1/fees/expression-of-interest-subscription-details-by-user?userId=${studentData?.userId}`,
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    const data = response?.data?.data;
                    const activitySubscriptionId = data?.find((item) => item?.interestType === 'ACTIVITY')?.id;
                    const activityDetails = data
                        ?.flatMap((item) => item?.subscriptionDetailsList || [])
                        ?.filter((elem) => elem?.subscriptionItem?.interestType === 'ACTIVITY')
                        ?.flatMap((el) => el?.subscriptionItem?.id?.toString());
                    const activityTotal = calculateTotalAmount(activities, activityDetails);
                    setTotalActivityAmount(activityTotal);
                    setSelectedActivity(activityDetails);
                    setActivitySubscriptionId(activitySubscriptionId);
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const cancelSubscription = async (subscriptionId) => {
        try {
            const response = await axios.put(
                `/v1/fees/subscription-remove-for-admission?userId=${studentData?.userId}&subscriptionId=${subscriptionId}`,
                {},
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    showMessage({ message: response?.data?.Msg, color: 'error' });
                    setSelectedActivity([]);
                    setOpenActivity(false);
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const calculateTotalAmount = (feeHeads, selectedIds) =>
        feeHeads?.reduce((total, item) => {
            const amountString = String(item?.amount || '0');
            if (selectedIds?.includes(item?.id?.toString())) {
                const fee = parseFloat(amountString?.replace(/[^\d.]/g, ''));
                if (!isNaN(fee)) {
                    return total + fee;
                }
            }
            return total;
        }, 0);
    useEffect(() => {
        fetchIntrestCategories();
        if (studentData?.studentSignature || studentData?.declarations[0]?.signatureFile)
            fetchSignature(studentData?.studentSignature || studentData?.declarations[0]?.signatureFile);
    }, []);

    useEffect(() => {
        const total = calculateTotalAmount(activities, selectedActivity);
        setTotalActivityAmount(total);
    }, [selectedActivity]);
    return (
        <MainCard>
            <Box
                sx={{
                    fontFamily: 'Arial, sans-serif',
                    maxWidth: '800px',
                    mx: 'auto',
                    p: 3,
                    bgcolor: '#ddb8ef',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                }}
            >
                <Box
                    sx={{
                        textAlign: 'center',
                        mb: 3,
                        pb: 2,
                        borderBottom: '2px solid #4a2a82',
                        bgcolor: '#ddb8ef'
                    }}
                >
                    <Box display="flex" justifyContent="center" p={2}>
                        <img src="/UniversityHeader.png" alt="University Header" style={{ maxWidth: '100%', height: 'auto' }} />
                    </Box>
                    <Typography sx={{ fontSize: '18px', color: '#4a2a82', fontWeight: 'bold', mt: 2 }}>
                        USTM Activity Centre <br />
                        Expression of Interest
                    </Typography>
                </Box>

                <Typography sx={{ fontSize: '14px', mb: 3, textAlign: 'justify', lineHeight: 1.6 }}>
                    Extra-curricular & Co-Curricular activities under different FORUMS to be offered to all students during their academic
                    tenure at USTM. Every student has to pay an annual fee as prescribed below for general membership for various activities
                    of your choice by paying the annual fee as prescribed. (Please choose the item from the Privileged Membership column)
                </Typography>

                <Paper sx={{ border: '1px solid #4a2a82', mb: 3, bgcolor: 'rgba(255,255,255,0.7)' }}>
                    <Box sx={{ overflowX: 'auto' }}>
                        <Table size="small" sx={{ minWidth: 700 }}>
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#4a2a82' }}>
                                    {['Sl. No', 'Forum', 'Content', 'Privileged Membership (Optional)', 'Tick in appropriate box'].map(
                                        (head) => (
                                            <TableCell
                                                key={head}
                                                style={{ color: 'white', textAlign: 'center', border: '1px solid #4a2a82', px: 1 }}
                                            >
                                                {head}
                                            </TableCell>
                                        )
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {activities.map((activity, i) => (
                                    <TableRow key={activity?.id} sx={{ backgroundColor: activity?.id % 2 === 0 ? '#f2e6ff' : 'white' }}>
                                        <TableCell sx={{ border: '1px solid #4a2a82', textAlign: 'center' }}>{i + 1}</TableCell>
                                        <TableCell sx={{ border: '1px solid #4a2a82' }}>{activity?.name}</TableCell>
                                        <TableCell sx={{ border: '1px solid #4a2a82' }}>{activity?.description}</TableCell>
                                        <TableCell sx={{ border: '1px solid #4a2a82', textAlign: 'center' }}>
                                            Rs. {activity?.amount}/-
                                        </TableCell>
                                        <TableCell sx={{ border: '1px solid #4a2a82', textAlign: 'center' }}>
                                            <Checkbox
                                                id={`activity-${activity?.id}`}
                                                name="activities"
                                                value={activity?.id}
                                                checked={selectedActivity?.includes(activity?.id?.toString())}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    const checked = e.target.checked;
                                                    setSelectedActivity((prev) =>
                                                        checked ? [...prev, val] : prev.filter((id) => id !== val)
                                                    );
                                                }}
                                                sx={{ width: '16px', height: '16px', p: 0 }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow sx={{ backgroundColor: '#e6c3f2', fontWeight: 'bold' }}>
                                    <TableCell colSpan={3} sx={{ textAlign: 'right', border: '1px solid #4a2a82' }}>
                                        Total Amount
                                    </TableCell>
                                    <TableCell colSpan={2} sx={{ textAlign: 'center', border: '1px solid #4a2a82' }}>
                                        Rs. {totalActivityAmount} /-
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                </Paper>

                <Box>
                    <LabelledField label="Name of the Student:">
                        <CustomTextField value={studentData?.studentName} />
                    </LabelledField>
                    <Grid container spacing={2} mb={2}>
                        <Grid item xs={12} sm={6}>
                            <LabelledField label="Roll No:" labelWidth="80px">
                                <CustomTextField value={studentData?.rollNo} />
                            </LabelledField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <LabelledField label="Contact No:" labelWidth="120px">
                                <CustomTextField value={studentData?.personalDetails?.phone} />
                            </LabelledField>
                        </Grid>
                    </Grid>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: { xs: 'column', sm: 'row' },
                        mt: 4,
                        gap: 4
                    }}
                >
                    <Box>
                        {(studentData?.studentSignature || studentData?.declarations[0]?.signatureFile) && (
                            <img
                                src={signature || studentData?.declarations[0]?.signatureFile}
                                alt="Student"
                                style={{
                                    maxWidth: '100%',
                                    width: '200px',
                                    height: 'auto',
                                    border: '1px solid #ccc',
                                    borderRadius: 4,
                                    marginBottom: '20px'
                                }}
                            />
                        )}
                        <Box sx={{ borderTop: '1px solid #4a2a82', width: '200px', pt: 1 }}>Signature of the Student</Box>
                    </Box>
                    <Box textAlign="center">
                        <Box sx={{ height: '72px' }} />
                        <Box sx={{ borderTop: '1px solid #4a2a82', width: '200px', pt: 1 }}>(Authorized Signature)</Box>
                    </Box>
                </Box>

                <Box display="flex" justifyContent="flex-end" gap={2} mt={4}>
                    {/* <Button color="error" variant="contained" onClick={() => setOpenActivity(true)}>
                        Cancel Subscription
                    </Button> */}
                    <Button
                        startIcon={isLoading && <CircularProgress color="error" size="1rem" />}
                        onClick={() => {
                            handleSubscription();
                        }}
                        disabled={isLoading || selectedActivity?.length === 0}
                        color="secondary"
                        variant="contained"
                    >
                        {isLoading ? 'Please Wait' : studentData?.interestActivity ? 'Update' : 'Submit'}
                    </Button>
                </Box>

                <Dialog open={openActivity} onClose={() => setOpenActivity(false)}>
                    <DialogTitle>Cancel Subscription</DialogTitle>
                    <DialogContent sx={{ width: '100%', maxWidth: '500px', p: 3 }}>
                        <Typography variant="body1">
                            Are you sure you want to cancel your subscription? This action cannot be undone.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenActivity(false)} color="secondary" variant="contained">
                            No, keep it
                        </Button>
                        <Button
                            onClick={() => cancelSubscription(activitySubscriptionId, 'ACTIVITY')}
                            color="error"
                            variant="contained"
                            autoFocus
                        >
                            Yes, cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </MainCard>
    );
};

export default ExtraCurricular;
